module.exports = "./img/c6b997facae5961da130f9c44e38e56d.png";